import { plural } from '@remote-medium/shared';
import { cn } from '@remote-medium/ui';
import { ChevronRight } from 'lucide-react';
import { Link } from 'react-router';

import { CARD, H2 } from '../../../lib/ui.tsx';
import type { Task } from './tasks.ts';

function TaskRow({ task: { icon: Icon, title, detail, action, to } }: { task: Task }) {
  return (
    <li className="border-b border-border last:border-b-0">
      <Link
        to={to}
        className="grid grid-cols-[20px_minmax(0,1fr)_auto] items-center gap-4 px-5 py-4 no-underline hover:bg-muted/50 first:rounded-t-xl last:rounded-b-xl"
      >
        <Icon aria-hidden="true" className="size-5 text-muted-foreground" />
        <div className="flex min-w-0 flex-col gap-0.5">
          <span className="text-sm font-semibold text-foreground">{title}</span>
          <span className="text-sm text-pretty text-muted-foreground">{detail}</span>
        </div>
        <span className="flex items-center gap-3 text-xs text-muted-foreground">
          <span className="hidden sm:inline">{action}</span>
          <ChevronRight aria-hidden="true" className="size-4" />
        </span>
      </Link>
    </li>
  );
}

export function WaitingOnYou({ tasks, clear }: { tasks: Task[]; clear: string[] }) {
  return (
    <section className="flex flex-col gap-3">
      <div className="flex items-baseline justify-between gap-4">
        <h2 className={H2}>Waiting on you</h2>
        <span className="text-xs text-muted-foreground">
          {tasks.length ? `${plural(tasks.length, 'item')} · oldest first` : 'All clear'}
        </span>
      </div>
      {tasks.length ? (
        <ul className={cn(CARD, 'm-0 flex list-none flex-col p-0')}>
          {tasks.map((t) => (
            <TaskRow key={t.key} task={t} />
          ))}
        </ul>
      ) : (
        <div className={cn(CARD, 'px-5 py-8 text-sm text-muted-foreground')}>
          Nothing waiting on you. New candidates, ranked matches and consent replies show up here.
        </div>
      )}
      {clear.length > 0 && (
        <p className="m-0 text-xs text-muted-foreground">Also clear: {clear.join(', ')}.</p>
      )}
    </section>
  );
}
